import { ShoppingCart, List, SignOut, X } from "@phosphor-icons/react";
import logo from "../assets/images/visaro-logo-white.svg";
import { NavLink, useLocation } from "react-router-dom";
import { FC, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";

const navItems = [
  { to: "home", label: "Home" },
  { to: "marketplace", label: "Marketplace" },
  { to: "payments/history", label: "Payments" },
  { to: "send", label: "Send" },
  { to: "cards", label: "Cards" },
  { to: "payments/loans", label: "Your loans" },
  { to: "aviation/your-flights", label: "Your Flights" },
  { to: "/home/settings", label: "Settings" },
  { to: "help", label: "Help" },
  { to: "support", label: "Support" },
];

const DashboardNavbar: FC<{}> = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <nav className="p-4 md:px-10 flex items-center justify-between bg-deepBlue text-white relative z-50">
        <div className="flex items-center gap-6">
          <button
            onClick={() => setIsOpen(true)}
            className="md:hidden text-white"
          >
            <List size={28} />
          </button>
          <NavLink to={"home"}>
            <img src={logo} alt="Visaro Logo" />
          </NavLink>
          <div className="hidden lg:flex items-center gap-6">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className="nav-link items-center gap-2"
              >
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <a
            rel="noreferrer"
            target="_blank"
            href="https://merchant.visaro.ng/login"
            className="nav-link hidden lg:flex"
          >
            <div>Switch to Business</div>
          </a>
          <NavLink
            title="Cart"
            to={`/cart`}
            state={{ background: location, name: "cart" }}
            className="p-2 bg-visaro-gray-700 rounded-lg"
          >
            <ShoppingCart size={20} />
          </NavLink>
          <NavLink
            title="Profile"
            to="/home/settings/profile"
            className="rounded-lg"
          >
            <img
              src={user?.photo || ""}
              alt="you"
              className="w-10 aspect-square object-cover rounded-full bg-white"
            />
          </NavLink>
          <button
            type="button"
            title="Log out"
            onClick={() => logout()}
            className="p-2 bg-visaro-gray-700 rounded-lg hover:bg-visaro-gray-600"
            aria-label="Log out"
          >
            <SignOut size={22} />
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop */}
            <motion.div
              className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
            />

            {/* Side Nav */}
            <motion.div
              className="fixed top-0 left-0 bottom-0 w-64 bg-deepBlue text-white z-50 p-5 flex flex-col gap-4"
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              <div className="flex items-center justify-between mb-4">
                <img src={logo} alt="Visaro Logo" className="" />
                <button onClick={() => setIsOpen(false)}>
                  <X size={24} />
                </button>
              </div>

              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={() => setIsOpen(false)}
                  className="nav-link py-2"
                >
                  {item.label}
                </NavLink>
              ))}

              <a
                rel="noreferrer"
                target="_blank"
                href="https://merchant.visaro.ng/login"
                className="nav-link"
              >
                <div>Switch to Business</div>
              </a>

              <div className="mt-auto flex gap-3 items-center pt-5 border-t border-white/20">
                <img
                  src={user?.photo || ""}
                  alt="Profile"
                  className="w-10 h-10 rounded-full object-cover bg-white"
                />
                <NavLink
                  to="/home/settings/profile"
                  onClick={() => setIsOpen(false)}
                  className="truncate"
                >
                  <div>
                    {user?.firstname} {user?.lastname}
                  </div>
                  <div className="text-sm">View Profile</div>
                </NavLink>
                <button
                  type="button"
                  onClick={() => {
                    setIsOpen(false);
                    logout();
                  }}
                  className="nav-link py-2 flex items-center gap-2 text-left w-full"
                >
                  <SignOut size={20} />
                  Log out
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default DashboardNavbar;
